{
  "name": "metal-admin",
  "version": "1.1.12",
  "author": "Diptarghya Banerjee",
  "license": "MIT",
  "engines": {
    "node": "^18.13.0 || ^20.9.0",
    "npm": "9.x.x"
  },
  "scripts": {
    "ng": "ng",
    "dip": "ng serve -o",
    "build": "ng build",
    "buildserve": "ng serve",
    "agro": "ng serve --c=agro",
    "buildagroprod": "ng build --configuration=agroprod",
    "buildprod": "ng build -c=development",
    "buildproduat": "ng build --c=uat",
    "buildagro": "ng build --c=agro",
    "stqcbuild": "ng build --c=stqcbuild",
    "buildOptimizer": "ng build --aot && gzipper compress ./dist",
    "buildmetalqa": "ng build --c=qa",
    "buildagroqa": "ng build --c=agroqa",
    "buildagrouat": "ng build --c=agrouat",
    "buildfcidev": "ng build --c=fci",
    "buildfciqa": "ng build --c=fciqa",
    "buildfciuat": "ng build --c=fciuat",
    "fci": "ng serve --c=fci",
    "buildAot": "ng build --aot",
    "buildCommonChunk": "ng build --common-chunk",
    "buildOptimization": "ng build --optimization",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:once": "ng test --watch=false",
    "test:coverage": "ng test --watch=false --code-coverage",
    "test:ci": "ng test --browsers CIChromeHeadless --watch=false --code-coverage",
    "lint": "ng lint --max-warnings 0",
    "lint:fix": "ng lint --fix",
    "prettier": "prettier \"**/*.(ts|scss|html|js|json)\" --check",
    "prettier:fix": "prettier \"**/*.(ts|scss|html|js|json)\" --write"
  },
  "lint-staged": {
    "src/**/*.{ts,scss,html}": [
      "npm run prettier"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.0",
    "@angular/cdk": "^21.2.0",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/material": "^21.2.0",
    "@angular/material-moment-adapter": "^21.2.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.2.0",
    "@angular/router": "^21.2.0",
    "@fortawesome/angular-fontawesome": "^1.0.0",
    "@fortawesome/fontawesome-free": "^6.4.2",
    "@fortawesome/fontawesome-svg-core": "^6.4.2",
    "@fortawesome/free-regular-svg-icons": "^6.4.2",
    "@highcharts/dashboards": "^1.2.0",
    "@highcharts/map-collection": "^2.1.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.0.0",
    "@ngneat/content-loader": "^7.0.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@ngxs/logger-plugin": "^21.0.0",
    "@ngxs/store": "^21.0.0",
    "@popperjs/core": "^2.11.8",
    "@stomp/stompjs": "^7.0.0",
    "@types/highcharts": "^7.0.0",
    "angular-cd-timer": "^3.0.0",
    "angular-datatables": "^19.0.0",
    "angular-feather": "^6.5.0",
    "angular-ng-stepper": "^2.0.0",
    "bcryptjs": "^2.4.3",
    "bootstrap": "^5.3.2",
    "boxicons": "^2.1.4",
    "crypto-js": "~4.1.1",
    "datatables.net": "^2.1.8",
    "datatables.net-dt": "^2.1.8",
    "datatables.net-fixedheader": "^4.0.0",
    "dotenv": "^16.3.1",
    "file-saver": "^2.0.5",
    "highcharts": "~11.1.0",
    "highcharts-angular": "^4.0.1",
    "increase-memory-limit": "^1.0.7",
    "jquery": "^3.7.1",
    "moment": "^2.29.4",
    "ng-angular-popup": "^0.5.2",
    "ng-circle-progress": "^1.7.1",
    "ng-multiselect-dropdown": "^1.0.0",
    "ng-recaptcha": "^13.2.1",
    "ngx-extended-pdf-viewer": "21.3.6",
    "ngx-owl-carousel-o": "^21.0.0",
    "ngx-select-dropdown": "^3.3.1",
    "ngx-skeleton-loader": "^10.0.0",
    "ngx-toastr": "^20.0.0",
    "rxjs": "~7.8.1",
    "sockjs-client": "^1.6.1",
    "stompjs": "^2.3.3",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.2.0",
    "@angular-eslint/builder": "^21.0.0",
    "@angular-eslint/eslint-plugin": "^21.0.0",
    "@angular-eslint/eslint-plugin-template": "^21.0.0",
    "@angular-eslint/schematics": "^21.0.0",
    "@angular-eslint/template-parser": "^21.0.0",
    "@angular/cli": "~21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@angular/localize": "^21.2.0",
    "@types/bootstrap": "^5.2.7",
    "@types/crypto-js": "^4.1.2",
    "@types/datatables.net": "^1.12.3",
    "@types/jasmine": "~4.3.6",
    "@types/jquery": "^3.5.19",
    "@types/node": "^26.1.0",
    "@typescript-eslint/eslint-plugin": "7.11.0",
    "@typescript-eslint/parser": "7.11.0",
    "autoprefixer": "^10.4.15",
    "dotenv-webpack": "^8.1.0",
    "eslint": "^9.16.0",
    "eslint-config-prettier": "^9.0.0",
    "eslint-plugin-jasmine": "^4.1.3",
    "eslint-plugin-prettier": "^5.0.0",
    "eslint-plugin-rxjs": "^5.0.3",
    "jasmine-core": "~5.1.1",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "karma-spec-reporter": "^0.0.36",
    "postcss": "^8.4.29",
    "postcss-import": "^15.1.0",
    "postcss-nesting": "^12.0.1",
    "script-loader": "^0.7.2",
    "tailwindcss": "^3.3.3",
    "typescript": "~5.9.0",
    "xlsx": "^0.18.5"
  },
  "browser": {
    "crypto": false
  },
  "description": "This project was generated with [Angular CLI](https://github.com/angular/angular-cli) version 16.1.0.",
  "main": "postcss.config.js"
}
